import {AttrsSchema, Component, ConfigOptions} from 'panel';

import {FormattedProperty, getFormattedPropertyName} from 'common/util/format-property';
import {baseComparator} from 'common/util';
import {FormattedPropertyLayout} from 'common/widgets/profile-activity/formatted-property/template';
import {defineAndMakeJsxFactory} from 'common/util/jsx';
import {panel2react} from 'common/util/react';

import {ActivityPropertyState, EventPropertyToggleChoices, SplitProperties} from './types';
import {template} from './template';
import './index.styl';

export class ProfileActivityProperties extends Component<ActivityPropertyState> {
  static get attrsSchema(): AttrsSchema<{
    'event-name': string;
    time: string;
    'user-defined-event-properties': FormattedProperty[];
    'mixpanel-properties': FormattedProperty[];
    'utc-offset': number;
  }> {
    return {
      ...super.attrsSchema,
      'event-name': `string`,
      time: `string`,
      'user-defined-event-properties': `json`,
      'mixpanel-properties': `json`,
      'utc-offset': `number`,
    };
  }

  get config(): ConfigOptions<ActivityPropertyState> {
    return {
      defaultState: {
        selectedToggle: EventPropertyToggleChoices.ALL_EVENT_PROPERTIES,
      },
      template,
      helpers: {
        FormattedPropertyLayout,
        EventPropertyToggleChoices,
        onToggleChange: ({detail: {selected}}): void => {
          this.update({selectedToggle: selected});
        },
        propertiesToggleOptions: ({allPropertiesLength, userDefinedPropertiesLength, mixpanelLength}): string =>
          JSON.stringify([
            {
              value: EventPropertyToggleChoices.ALL_EVENT_PROPERTIES,
              label: `${EventPropertyToggleChoices.ALL_EVENT_PROPERTIES} (${allPropertiesLength})`,
            },
            {
              value: EventPropertyToggleChoices.USER_DEFINED_EVENT_PROPERTIES,
              label: `${EventPropertyToggleChoices.USER_DEFINED_EVENT_PROPERTIES} (${userDefinedPropertiesLength})`,
            },
            {
              value: EventPropertyToggleChoices.MIXPANEL_EVENT_PROPERTIES,
              label: `${EventPropertyToggleChoices.MIXPANEL_EVENT_PROPERTIES} (${mixpanelLength})`,
            },
          ]),
        splitPropertiesForEvent: (): SplitProperties => {
          const mixpanelProperties = this.attr(`mixpanel-properties`);
          const userDefinedEventProperties = this.attr(`user-defined-event-properties`);

          const comparator = baseComparator<any, string>({
            transform: (prop) => getFormattedPropertyName(prop).toLowerCase(),
          });

          mixpanelProperties.sort(comparator);

          const allProperties = mixpanelProperties.concat(userDefinedEventProperties).sort(comparator);

          return {
            allProperties,
            userDefinedProperties: userDefinedEventProperties,
            mixpanelProperties,
          };
        },
      },
    };
  }
}

export const ProfileActivityPropertiesEl = defineAndMakeJsxFactory(
  `profile-activity-properties`,
  ProfileActivityProperties,
);
export const ProfileActivityPropertiesReact = panel2react(`profile-activity-properties`, ProfileActivityProperties);
